import { render, staticRenderFns } from "./fatture.vue?vue&type=template&id=299be543&scoped=true&lang=html"
import script from "./fatture.vue?vue&type=script&lang=js"
export * from "./fatture.vue?vue&type=script&lang=js"
import style0 from "./fatture.vue?vue&type=style&index=0&id=299be543&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299be543",
  null
  
)

export default component.exports